import z from 'zod';

export const addSizeSchema = z.object({
  sizeId: z.string().min(1, 'Size is required'),
  quantity: z.preprocess(
    (val) => {
      if (typeof val === 'string' && val.trim() !== '') {
        return Number(val);
      }
      if (typeof val === 'number') {
        return val;
      }
      return val;
    },
    z
      .number({
        required_error: 'Quantity is required',
        invalid_type_error: 'Quantity is required',
      })
      .min(0, 'Quantity must be greater or equal to 0')
  ),
});

export type AddSizeValues = z.infer<typeof addSizeSchema>;
